const bedc = [
	'bedc:user:admin-user',
	'bedc:user:internal-user',
	'bedc:user:saas-user',
	'bedc:user:client-user',

	'bedc:user:read/admin',
	'bedc:user:read/admin/activity',
	'bedc:user:read/performance-chart',
	'bedc:user:read/my-performance-chart',
	'bedc:user:read/profile/productivity',
	'bedc:user:read/override',
	'bedc:user:read/user-group/rome-dev',
	'bedc:user:read/user-group/ai-dev',
	'bedc:user:read/user-group/system-admin',
	'bedc:user:read/user-group/support',
	'bedc:user:read/user-group/alpine-support',
	'bedc:user:read/user-group/manager',
	'bedc:user:read/user-group/accounting',
	'bedc:user:read/user-group/team-leader',
	'bedc:user:read/user-group/estimator',
	'bedc:user:read/user-group/estimator+external',
	'bedc:user:read/user-group/client',
	'bedc:user:read/user-group/client-manager',
	'bedc:user:read/user-group/sales',
	'bedc:user:read/user-group/customer',
	'bedc:user:read/user-group/saas-manager',
	'bedc:user:read/user-group/saas-accounting',
	'bedc:user:read/user-group/saas-estimator',
	'bedc:user:read/user-group/saas-sales',
	'bedc:user:read/user-group/saas-production',
	'bedc:user:read/user-group/saas-delivery',
	'bedc:user:read/user-group/recipe-admin',
	'bedc:user:read/user-group/hitl-specialist',

	'bedc:user:lookup',

	'bedc:user:list',

	'bedc:user:search/admin',
	'bedc:user:search/estimators',

	'bedc:user:create',
	'bedc:user:create/user-group/rome-dev',
	'bedc:user:create/user-group/ai-dev',
	'bedc:user:create/user-group/system-admin',
	'bedc:user:create/user-group/support',
	'bedc:user:create/user-group/alpine-support',
	'bedc:user:create/user-group/accounting',
	'bedc:user:create/user-group/manager',
	'bedc:user:create/user-group/team-leader',
	'bedc:user:create/user-group/estimator',
	'bedc:user:create/user-group/estimator+external',
	'bedc:user:create/user-group/hitl-specialist',
	'bedc:user:create/user-group/client',
	'bedc:user:create/user-group/client-manager',
	'bedc:user:create/user-group/sales',
	'bedc:user:create/user-group/customer',
	'bedc:user:create/user-group/saas-manager',
	'bedc:user:create/user-group/saas-accounting',
	'bedc:user:create/user-group/saas-estimator',
	'bedc:user:create/user-group/saas-sales',
	'bedc:user:create/user-group/saas-production',
	'bedc:user:create/user-group/saas-delivery',
	'bedc:user:create/user-group/recipe-admin',

	'bedc:user:update',
	'bedc:user:update/user-group/rome-dev',
	'bedc:user:update/user-group/ai-dev',
	'bedc:user:update/user-group/system-admin',
	'bedc:user:update/user-group/support',
	'bedc:user:update/user-group/alpine-support',
	'bedc:user:update/user-group/accounting',
	'bedc:user:update/user-group/manager',
	'bedc:user:update/user-group/team-leader',
	'bedc:user:update/user-group/estimator',
	'bedc:user:update/user-group/estimator+external',
	'bedc:user:update/user-group/hitl-specialist',
	'bedc:user:update/user-group/client',
	'bedc:user:update/user-group/client-manager',
	'bedc:user:update/user-group/sales',
	'bedc:user:update/user-group/customer',
	'bedc:user:update/user-group/saas-manager',
	'bedc:user:update/user-group/saas-accounting',
	'bedc:user:update/user-group/saas-estimator',
	'bedc:user:update/user-group/saas-sales',
	'bedc:user:update/user-group/saas-production',
	'bedc:user:update/user-group/saas-delivery',
	'bedc:user:update/user-group/recipe-admin',
	'bedc:user:update/override/scopes',
	'bedc:user:update/override/scope/simpleOverride',

	'bedc:user:update/password',
	'bedc:user:update/password/user-group/rome-dev',
	'bedc:user:update/password/user-group/ai-dev',
	'bedc:user:update/password/user-group/system-admin',
	'bedc:user:update/password/user-group/support',
	'bedc:user:update/password/user-group/alpine-support',
	'bedc:user:update/password/user-group/accounting',
	'bedc:user:update/password/user-group/manager',
	'bedc:user:update/password/user-group/team-leader',
	'bedc:user:update/password/user-group/estimator',
	'bedc:user:update/password/user-group/estimator+external',
	'bedc:user:update/password/user-group/hitl-specialist',
	'bedc:user:update/password/user-group/client',
	'bedc:user:update/password/user-group/client-manager',
	'bedc:user:update/password/user-group/sales',
	'bedc:user:update/password/user-group/customer',
	'bedc:user:update/password/user-group/saas-manager',
	'bedc:user:update/password/user-group/saas-accounting',
	'bedc:user:update/password/user-group/saas-estimator',
	'bedc:user:update/password/user-group/saas-sales',
	'bedc:user:update/password/user-group/saas-production',
	'bedc:user:update/password/user-group/saas-delivery',
	'bedc:user:update/password/user-group/recipe-admin',

	'bedc:user:update/status',
	'bedc:user:update/status/user-group/estimator',
	'bedc:user:update/status/user-group/estimator+external',
	'bedc:user:update/skills',
	'bedc:user:update/skills/user-group/estimator',
	'bedc:user:update/skills/user-group/estimator+external',

	'bedc:user:delete',
	'bedc:user:delete/user-group/rome-dev',
	'bedc:user:delete/user-group/ai-dev',
	'bedc:user:delete/user-group/system-admin',
	'bedc:user:delete/user-group/support',
	'bedc:user:delete/user-group/alpine-support',
	'bedc:user:delete/user-group/accounting',
	'bedc:user:delete/user-group/manager',
	'bedc:user:delete/user-group/team-leader',
	'bedc:user:delete/user-group/estimator',
	'bedc:user:delete/user-group/estimator+external',
	'bedc:user:delete/user-group/hitl-specialist',
	'bedc:user:delete/user-group/client',
	'bedc:user:delete/user-group/client-manager',
	'bedc:user:delete/user-group/sales',
	'bedc:user:delete/user-group/customer',
	'bedc:user:delete/user-group/saas-manager',
	'bedc:user:delete/user-group/saas-accounting',
	'bedc:user:delete/user-group/saas-estimator',
	'bedc:user:delete/user-group/saas-sales',
	'bedc:user:delete/user-group/saas-production',
	'bedc:user:delete/user-group/saas-delivery',
	'bedc:user:delete/user-group/recipe-admin',
	'bedc:user:delete/override',
] as const;

const integration = [
	'integration:user:create/identity',
	'integration:user:read',
	'integration:user:list',
	'integration:user:update/identity',
] as const;

export default [...bedc, ...integration] as const;
